(function() {
  var body = document.body,
      dropArea = document.getElementById( 'drop-area' ),
      droppableArr = [], dropAreaTimeout;

  // initialize flickty
  var $gallery = $('.main-gallery').flickity({
    // options
    draggable: false,
    cellAlign: 'left'
  });

  GetCartInformation();

  // initialize droppables
  [].slice.call( document.querySelectorAll( '#drop-area .drop-area__item' )).forEach( function( el ) {
    droppableArr.push( new Droppable( el, {
      onDrop : function( instance, draggableEl ) {
        // show checkmark inside the droppabe element
        classie.add( instance.el, 'drop-feedback' );
        clearTimeout( instance.checkmarkTimeout );
        instance.checkmarkTimeout = setTimeout( function() { 
          classie.remove( instance.el, 'drop-feedback' );
        }, 800 );

        var prodId = $('div.grid__item.is-active').data("id");
        AddToCart(prodId);

      }
    } ) );
  } );

  // initialize draggable(s)
  [].slice.call(document.querySelectorAll( '#grid .grid__item' )).forEach( function( el ) {
    new Draggable( el, droppableArr, {
      scroll : true,
      scrollable : '#drop-area',
      scrollSpeed : 40,
      scrollSensitivity : 50,
      draggabilly : { containment: document.body },
      onStart : function() {
        // add class 'drag-active' to body
        classie.add( body, 'drag-active' );
        // clear timeout: dropAreaTimeout (toggle drop area)
        clearTimeout( dropAreaTimeout );
        // show dropArea
        classie.add( dropArea, 'show' );
      },
      onEnd : function( wasDropped ) {              
        var afterDropFn = function() {
          // hide dropArea
          classie.remove( dropArea, 'show' );
          // remove class 'drag-active' from body
          classie.remove( body, 'drag-active' );
        };
        if( !wasDropped ) {
          afterDropFn();
        }
        else {
          // after some time hide drop area and remove class 'drag-active' from body
          clearTimeout( dropAreaTimeout );
          dropAreaTimeout = setTimeout( afterDropFn, 400 );
        }
      }
    } );
  } );


  // AJAX calls:
  // -----------

  function AddToCart(productId)
  {
    var desiredQuantity = 1;
    var desiredproductId =parseInt(productId);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { quantity: desiredQuantity, id: desiredproductId },
      success: function(data)
      {    
        GetCartInformation();
      },
      error: function(XMLHttpRequest, textStatus)
      {      
        // Shows error information
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        if (!!data.message) {
          swal({ title: "Oops!", 
                text: data.description, 
                type: "error", 
                confirmButtonText: "Alright" });
        } else {
          swal({ title: "Oops!", 
                text: Shopify.fullMessagesFromErrors(data).join('; '), 
                type: "error", 
                confirmButtonText: "Alright" });
        }        
      }
    });
  }

  function RemoveFromCart(productId)
  {
    var desiredQuantity = 0;
    var desiredproductId = parseInt(productId);

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: { quantity: desiredQuantity, id: desiredproductId },
      success: function(data)
      {    
        GetCartInformation();            
      },
      error: function(XMLHttpRequest, textStatus)
      {      
        // Shows error information
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        if (!!data.message) {
          swal({ title: "Oops!", 
                text: data.description, 
                type: "error", 
                confirmButtonText: "Alright" });
        } else {
          swal({ title: "Oops!", 
                text: Shopify.fullMessagesFromErrors(data).join('; '), 
                type: "error", 
                confirmButtonText: "Alright" });
        }        
      }
    });
  }

  // Gets the products added to the cart
  function GetCartInformation()
  {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(data)
      {    
        UpdateCartInformation(data);
      },
      error: function(XMLHttpRequest, textStatus)
      {      
        // Shows error information
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        if (!!data.message) {
          swal({ title: "Oops!", 
                text: data.description, 
                type: "error", 
                confirmButtonText: "Alright" });
        } else {
          swal({ title: "Oops!", 
                text: Shopify.fullMessagesFromErrors(data).join('; '), 
                type: "error", 
                confirmButtonText: "Alright" });
        }        
      }
    });
  }

  // Updates the cart info displayed in the page
  function UpdateCartInformation(cart)
  {
    var items = cart.items;
    var totalPrice = cart.total_price;
    var $cartInformation = $('#table');
    var $cartInformationMobile = $('#table-mobile');

    // Cleans the information displayed
    $cartInformation.html('');
    $cartInformationMobile.html('');

    for(var i=0; i< items.length; i++)
    {
      $cartInformation.append(
        "<tr class='item'>" +
        "<td class='title text-left'>" +
        "<a href='" + items[i].url + "'>" +
        items[i].title +
        "</a>" +
        "</td>" +
        "<td>" + 
        "<span class='money'>"  +
        parseFloat(items[i].price/100) + " GBP" +
        "</span>" +
        "</td>" +
        "<td>" + items[i].quantity + "</td>" +
        "<td><i class=\"fa fa-times remove-item\" data-prodid=\"" + items[i].id + "\"></i></td>" +
        "</tr>"
      );

      $cartInformationMobile.append(
        "<tr class='item'>" +
        "<td class='title text-left'>" +
        "<a href='" + items[i].url + "'>" +
        items[i].title +
        "</a>" +
        "</td>" +
        "<td>" + 
        "<span class='money'>"  +
        parseFloat(items[i].price/100) + " GBP" +
        "</span>" +
        "</td>" +
        "<td>" + items[i].quantity + "</td>" +
        "<td><i class=\"fa fa-times remove-item\" data-prodid=\"" + items[i].id + "\"></i></td>" +
        "</tr>"
      );
    }

    $('#total').html(
      "<span class=money>" +
      parseFloat(totalPrice) + " GBP" +
      "</span>"
    );

    $('#total-mobile').html(
      "<span class=money>" +
      parseFloat(totalPrice) + " GBP" +
      "</span>"
    );


    var currency = $('.currencies .active').text().trim().substring(0,3);
    Currency.convertAll("GBP", currency, "span.money");    
  }

  $(document).ready(function(){
    GetCartInformation();

    // Attach the remove icons to the ajax event
    $(document).on("click", ".remove-item", function() {
      var productId = $(this).data("prodid");
      $(this).parents('tr').addClass("removed");
      RemoveFromCart(productId);
    });

    // Set the focus on the first gallery
    $('.gallery').first().flickity().focus();

  });


  // Aux methods
  // -----------

  // Binds the scrolling event to show prev/next products in Collection Page
  $('.main-gallery').bind('mousewheel DOMMouseScroll', function(e) {
    var scrollTo = null;  

    if (e.type == 'mousewheel') {
      scrollTo = (e.originalEvent.wheelDelta * -1);
    }
    else if (e.type == 'DOMMouseScroll') {
      scrollTo = 40 * e.originalEvent.detail;
      console.log("2");
    }

    if (scrollTo > 0) {
      e.preventDefault();
      $(this).flickity( 'next', false );
    } else if (scrollTo < 0) {
      e.preventDefault();
      $(this).flickity('previous', false);    
    }
  });

  // Binds the scrolling event to show prev/next products in Product Page
  $('.gallery-nav').bind('mousewheel DOMMouseScroll', function(e) {
    var scrollTo = null;  

    if (e.type == 'mousewheel') {
      scrollTo = (e.originalEvent.wheelDelta * -1);
    }
    else if (e.type == 'DOMMouseScroll') {
      scrollTo = 40 * e.originalEvent.detail;
      console.log("2");
    }

    if (scrollTo > 0) {
      e.preventDefault();
      $(this).flickity( 'next', false );
    } else if (scrollTo < 0) {
      e.preventDefault();
      $(this).flickity('previous', false);    
    }
  });
  
  $('.gallery-main').bind('mousewheel DOMMouseScroll', function(e) {
    var scrollTo = null;  

    if (e.type == 'mousewheel') {
      scrollTo = (e.originalEvent.wheelDelta * -1);
    }
    else if (e.type == 'DOMMouseScroll') {
      scrollTo = 40 * e.originalEvent.detail;
      console.log("2");
    }

    if (scrollTo > 0) {
      e.preventDefault();
      $(this).flickity( 'next', false );
    } else if (scrollTo < 0) {
      e.preventDefault();
      $(this).flickity('previous', false);    
    }
  });

  // Show cart button
  $('.show-cart').click(function(){
    $('.drop-area').toggleClass("show");
  });

  $('.drop-overlay').click(function(){
    $('.drop-area').removeClass("show");
  });

})();

